import { useAuth } from "@stores/auth-store";
import DashboardLayout from "@pma/app/dashboard/layout";
import UserProfile from "@components/users/user-profile";

const ProfilePage = () => {
  const { authConfig } = useAuth();

  const userId = authConfig?.id;
  return (
    <DashboardLayout>
      <UserProfile userId={userId} />
    </DashboardLayout>
  );
};

export default ProfilePage;
